









import store from '@/store';

export default
  props:
    # ラベル
    label:
      type: String
      default: ''
    red:
      type: Boolean
      default: false
    mini:
      type: Boolean
      default: false
    disabled:
      type: Boolean
      default: false

  # click: クリックイベント
  methods: {
    click: (e) ->
      @$emit('click')
  }
